import React from "react";
import { useNavigate } from "react-router-dom";

import DataTable from "../../../../components/DataTable";
import pages from "../../../../constants/pages";
import { convertDate } from "../../../../utils";

export default function Table({ intents }) {
  const navigate = useNavigate();

  function handleClick(_, cellMetaData) {
    navigate(
      pages.botIntentDEtails.route + intents[cellMetaData.dataIndex].intent_name
    );
  }

  const options = {
    sortOrder: {
      name: "created_at",
      direction: "desc",
    },
    onCellClick: handleClick,
  };

  const columns = [
    {
      name: "intent_name",
      label: "Intent name",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Not Available";
        },
      },
    },
    {
      name: "regex",
      label: "No. of Regex",
      options: {
        customBodyRender: (value) => {
          return value
            ? value.length < 0
              ? 0
              : value.length
            : "Not Available";
        },
      },
    },

    {
      name: "examples",
      label: "No. of Examples",
      options: {
        customBodyRender: (value) => {
          return value
            ? value.length < 0
              ? 0
              : value.length
            : "Not Available";
        },
      },
    },
    {
      name: "created_at",
      label: "Created At",
      options: {
        customBodyRender: (value) => {
          return value ? convertDate(value) : "Not Available";
        },
      },
    },
    {
      name: "created_by",
      label: "Created By",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Not Available";
        },
      },
    },
  ];

  return <DataTable columns={columns} options={options} data={intents} />;
}
